import liveloBanner from 'assets/img/livelo-banner.png';

import ModalDoCatalogo from './ModalDoCatalogo';

/** Promoções da Livelo, aberto pela caixa rosa do cartão de Pontos Livelo (CAT-24). */
export default function ModalLivelo({ isOpen, onFechar }: { isOpen: boolean; onFechar: () => void }) {
  return (
    <ModalDoCatalogo isOpen={isOpen} tituloId="titulo-promocoes-livelo" descricaoId="descricao-promocoes-livelo" onFechar={onFechar}>
      <h2 id="titulo-promocoes-livelo" className="m-0 mb-2 pr-8 font-display text-[22px] font-extrabold text-brand-blue-dark">
        Promoções Livelo
      </h2>
      <p id="descricao-promocoes-livelo" className="m-0 mb-4 text-[13px] leading-[1.6]">
        Confira as promoções exclusivas da Livelo para esta opção de resgate.
      </p>
      <img
        src={liveloBanner}
        alt="Banner com promoções da Livelo para participantes do catálogo de experiências"
        className="block h-auto w-full rounded-lg"
      />
    </ModalDoCatalogo>
  );
}
